module.exports = __webpack_public_path__ + "static/media/memories_11.f918eef9.jpg";